import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import AppShell from "@/components/layout/AppShell";
import BoardroomPage from "@/components/boardroom/BoardroomPage";
import AgentsPage from "@/pages/AgentsPage";
import TasksPage from "@/pages/TasksPage";
import RoadmapPage from "@/pages/RoadmapPage";
import VaultPage from "@/pages/VaultPage";
import SettingsPage from "@/pages/SettingsPage";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import AuthCallback from "@/pages/AuthCallback";
import PublicVaultPage from "@/pages/PublicVaultPage";
import NotFoundPage from "@/components/common/NotFoundPage";
import OnboardingModal from "@/components/onboarding/OnboardingModal";
import RequireAuth from "@/components/auth/RequireAuth";
import { AuthProvider } from "@/lib/authContext";
import { useOnboardingSync } from "@/lib/onboarding";

function AppRouter() {
  // Sync server onboarding profile into the zustand store on auth changes.
  useOnboardingSync();
  // Detect the OAuth fragment SYNCHRONOUSLY during render, before any
  // ProtectedRoute check or AuthProvider /me call decides what to render.
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <OnboardingModal />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/share/vault/:token" element={<PublicVaultPage />} />
        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route path="/boardroom" element={<BoardroomPage />} />
          <Route path="/agents" element={<AgentsPage />} />
          <Route path="/tasks" element={<TasksPage />} />
          <Route path="/roadmap" element={<RoadmapPage />} />
          <Route path="/vault" element={<VaultPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors closeButton />
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
